import axios from "axios";
// config

// ----------------------------------------------------------------------

export const basePath = "https://api.queenssmile.co.kr";
// process.env.NODE_ENV === "production" ? HOST_API.production : HOST_API.dev;

const axiosInstance = axios.create({
  baseURL: basePath,
  timeout: 60 * 1000, // Timeout
  withCredentials: true, // Check cross-site Access-Control
});

export default axiosInstance;
